module.exports = __webpack_public_path__ + "img/flyer_02.60e3b739.jpeg";